var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reset-password"},[(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('steps',{attrs:{"current":_vm.current,"steps":_vm.steps}}),_c('router-view',{attrs:{"parent":_vm.routeName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }